import { WixUser } from '../../store';
import { UserAuthData, UserPlan } from '../../types';

export const getUserPlan = (user: WixUser | UserAuthData | undefined): UserPlan => {
  if (!user) {
    return 'free';
  }

  if ('accessToken' in user) {
    return user.plan;
  }

  return user.plan.name;
};
